import React from "react";
import { DistributorsListPage } from "../DistributorListPage/DistributorsListPage";

export const DistributorsList = () => {
  return <DistributorsListPage />;
};
